define ['./view.scss'], () ->
  saveAs = require("assets/FileSaver").saveAs

  ($state, RentappService, $timeout, $scope, $rootScope, $http, $window, $stateParams, $sce, $uibModal, $q, ApplicationBundle, Landlord, Application, RENTAPPLICATION_API_URL, Flash) ->
    $scope.current_state = 'application'
    rpt_error_svg = require('./../../../images/report-status-icon-error.svg')
    rpt_ready_svg = require('./../../../images/report-status-icon-ready.svg')
    rpt_pending_svg = require('./../../../images/report-status-icon-pending.svg')
    $scope.rpt_icon = {}
    $scope.tab_font_size = "18px"

    applicationId = $stateParams.application_id
    shareToken = $stateParams.shareToken
    re = /\/(\d+)\//;

    $scope.mobile_view = window.innerWidth < 768
    $scope.show_download_dropdown = false

    $scope.toggle_download_dropdown = () -> 
      $scope.show_download_dropdown = !$scope.show_download_dropdown
    
    Shepherd = require('tether-shepherd')
    $window.Shepherd = Shepherd

    $rootScope.$on "application-bundle-updated", (event, data) ->
      $scope.load_bundle($scope.application.id)

    if shareToken
      $http.post "#{RENTAPPLICATION_API_URL}/api/v1/user/login/", shareToken: shareToken
      .then (response) ->
        $state.go $state.current.name, {application_id: applicationId, shareToken: null}
      .catch (response) ->
        console.log "bad share token", shareToken
        $state.go $state.current.name, {application_id: applicationId, shareToken: null}
      return

    subMenu = $(".sticky-content")
    stickyFixed = "fixed"
    aboveSubMenuHeight = $('nav.ra-nav').height() + $('div.container').height() - 38
    $(window).scroll ->
      if $(this).scrollTop() > aboveSubMenuHeight
        subMenu.addClass stickyFixed
      else
        subMenu.removeClass stickyFixed
      return
      
    # If show_ambassador_program_toast = true
    $scope.show_ambassador_program_toast = () ->
      if mixpanel
        mixpanel.track('Ambassador Program banner shown')
      Flash.create('success', 'Invite agents who work in rentals to receive up to <strong>$1,000/referral.</strong><a href="#" ui-sref="root.dashboard.referral">See how much you can earn</a>' , 0, {class: "affiliate-promo"}, true)

      setTimeout(() ->
        $('.affiliate-promo span[aria-hidden="true"]').bind('click', (e) -> 
          mixpanel.track('Ambassador Program banner closed')
        )

        $('.affiliate-promo a').bind('click', (e) -> 
          mixpanel.track('Ambassador Program banner clicked')
        )
      , 10)
      
      
    $scope.start_sharee_intro_tour = () ->
      #$rootScope.$broadcast("intro-tour-started")

      tour = new Shepherd.Tour
        defaults:
          classes: 'shepherd-theme-arrows onboard-tour intro-steps'
      # Application Tab
      tour.addStep 'intro-step1',
        text: require('./tour/intro/step1.jade')
        attachTo: '.libutton.active bottom'
        showCancelLink: true
        buttons: [
          text: 'Next'
          action: tour.next
          classes: 'buttons onboard-button onboard-button-center'
        ]
        when:
          show: () ->
            if $scope.mobile_view
              angular.element('.applicant-button').css({'margin-left': '180px'})
      # Download Button
      tour.addStep 'intro-step2',
        text: require('./tour/intro/step2.jade')
        attachTo: '.about a.download right'
        showCancelLink: true
        buttons: [
          text: 'Back'
          action: tour.back
          classes: 'buttons onboard-button onboard-button-back'
        ,
          text: 'Next'
          action: tour.next
          classes: 'buttons onboard-button onboard-button-next'
        ]
        when:
          show: () ->
            if $scope.mobile_view
              angular.element('.form-button').css({position: 'relative'})
              angular.element('.applicant-button').css({'margin-left': '0px'})
      
      # Accept/Reject Button
      if $scope.bundle.decisioning_enabled != false
        tour.addStep 'intro-step3',
          text: require('./tour/intro/step3.jade')
          attachTo: ".accept-reject-container left"
          showCancelLink: true
          buttons: [
            text: 'Back'
            action: tour.back
            classes: 'buttons onboard-button onboard-button-back'
          ,
            text: 'Next'
            action: tour.next
            classes: 'buttons onboard-button onboard-button-next'
          ]
      
      # Other Actions
      tour.addStep 'intro-step4',
        text: require('./tour/intro/step4.jade')
        attachTo: ".bounce.bounce-button-view left"
        showCancelLink: true
        buttons: [
          text: 'Back'
          action: tour.back
          classes: 'buttons onboard-button onboard-button-back'
        ,
          text: 'Next'
          action: tour.next
          classes: 'buttons onboard-button onboard-button-next'
        ]
      
      # Groove Widget
      tour.addStep 'intro-step5',
        text: require('./tour/intro/step5.jade')
        attachTo: ".grv-widget-tag.grv-widget-tag-bottom-right top"
        showCancelLink: true
        buttons: [
          text: 'Back'
          action: tour.back
          classes: 'buttons onboard-button onboard-button-back'
        ,
          text: 'Got it'
          action: tour.next
          classes: 'buttons onboard-button onboard-button-next'
        ]

      tour.start()

    $scope.return_to_dashboard = () ->
      $state.go $scope.dashboard_link

    $scope.toggle_note = () ->
      $scope.note_toggled = !$scope.note_toggled

    $scope.move_left = () ->
      toolbarTab = document.querySelector('#topbarTabs.container')
      toolbarTab.scrollLeft -= 100;


    $scope.move_right = () ->
      toolbarTab = document.querySelector('#topbarTabs.container')
      toolbarTab.scrollLeft += 100;


    $scope.set_state = (profile) ->
      $scope.found_experian_credit = false
      if profile
        if profile.identifier == "experian_credit"
          $scope.found_experian_credit = true

        $scope.current_state = profile.short_label.toLowerCase()
        $state.go("root.dashboard.view_application.reports", {application: $scope.application, profile: profile})
      else
        $scope.current_state = 'application'
        $state.go("root.dashboard.view_application.application", { application: $scope.application })

    $scope.archive_application = () ->
      $scope.is_archiving = true

      Application.update({ id: $scope.application.id, is_archived: true }).$promise
        .then () ->
          Flash.create("success", 'Applicant successfully archived. Go to "Archived Applicants" to view', 3000, { class: 'arch-succ active' }, true)
          $rootScope.$broadcast("refresh-appbundle-table")
          $scope.application.is_archived = true
        .catch (error) ->
          Flash.create("danger", "Applicant could not be archived", 3000, { class: 'arch-error active' }, true)
        .finally () ->
          $scope.is_archiving = false

    $scope.unarchive_application = () ->
      $scope.is_archiving = true

      Application.update({ id: $scope.application.id, is_archived: false }).$promise
        .then () ->
          Flash.create("success", 'Applicant successfully unarchived. Go to "Active Applicants" to view', 3000, { class: 'arch-succ active' }, true)
          $rootScope.$broadcast("refresh-appbundle-table")
          $scope.application.is_archived = false
        .catch (error) ->
          Flash.create("danger", "Applicant could not be unarchived", 3000, { class: 'arch-error active' }, true)
        .finally () ->
          $scope.is_archiving = false
    
    $scope.open_welcome_modal = () ->
      $uibModal.open
        scope: $scope
        template: require("./tour/welcome/welcomeModal.jade")
        controller: require("./tour/welcome/welcomeModal.coffee")
        windowClass: 'welcome-modal'
      .result.then ((result) ->
        if result == 'start'
          $scope.start_sharee_intro_tour()
        console.log(result)
      )

    $scope.open_delete_modal = () ->
      $scope.bundles = [$scope.bundle]

      $uibModal.open
        scope: $scope
        template: require("./../../../directives/applicationDeleteModal/applicationDeleteModal.jade")
        controller: require("./../../../directives/applicationDeleteModal/applicationDeleteModal.coffee")
        windowClass: 'application-delete-modal'
      .result.then () ->
        console.log('deleted!')

    $scope.open_share_modal = () ->
      $scope.context = 'application'
      $uibModal.open
        scope: $scope
        template: require("./../../../directives/applicationShareModal/applicationShareModal.jade")
        controller: require("./../../../directives/applicationShareModal/applicationShareModal.coffee")
        windowClass: 'share-application-modal'
      .result.then () ->
        console.log('shared!')
    
    $scope.open_history_modal = () ->
      $uibModal.open
        scope: $scope
        template: require("./history/history.jade")
        controller: require("./history/history.coffee")
        windowClass: 'history-modal'
      .result.then (emails) ->
        console.log('history closed')

    $scope.update_notes = () ->
      $scope.is_saving_notes = true
      Application.update(id: $scope.application.id, { notes: $scope.application.notes }).$promise
        .then () ->
          $rootScope.$broadcast "refresh-appbundle-table"
        .catch (error) ->
          console.log(error)
        .finally () ->
          $scope.is_saving_notes = false
          $scope.note_toggled = null

    $scope.load_application = (app_id) ->
      landlordDefer = $q.defer()
      profiles_to_display = []
      RentappService.getMe().then (user) ->
        if user.landlord
          $scope.dashboard_link = "root.dashboard.applications"
          Landlord.getMe({with_stripe_data:true}).$promise.then (landlord) ->
            landlordDefer.resolve landlord
        else
          $scope.dashboard_link = "root.dashboard.applicant_applications"
          profiles_to_display = _.compact(_.map(application.reports, (report) ->
            rsp_to_add = report.report_source_profile
            # If report status is ready_user_action_required
            # remove from view by applicant
            if report.status == 'ready_user_action_required'
              return null
            if report.report_type
              rsp_to_add.report_type = report.report_type
              rsp_to_add.short_label = report.report_type[0].toUpperCase() + report.report_type[1..-1].toLowerCase()
            rsp_to_add.report = report
            rsp_to_add
          ))
          landlordDefer.resolve {}

      application = $scope.application =
        $.grep($scope.bundle.applications, (app)-> app.id == app_id)[0]
      $scope.app_field_names = []
      if application.form
        application.form.sections.forEach (section) ->
            section.fields.forEach (field) ->
              $scope.app_field_names.push field.name
      appLandlord = application.landlord
      
      if application.show_ambassador_program_toast
        setTimeout(() -> 
          Flash.clear()
          $scope.show_ambassador_program_toast()
        , 100)

      if $scope.bundle.reports_enabled != false
        profiles_to_display = _.filter(appLandlord.report_source_profiles, (rsp) ->
          rsp.identifier.indexOf('smartmove') < 0
        )
        
        application.reports.forEach (rep) ->
          reps_profile_already_displayed = $.grep(profiles_to_display, (prof) ->
            prof.identifier == rep.report_source_profile.identifier and rep.report_source_profile.identifier.indexOf('smartmove') < 0
          ).length
          if !reps_profile_already_displayed
            rsp_to_add = angular.copy(rep.report_source_profile)
            
            # This is for handling smartmove setup.
            if rep.report_type
              rsp_to_add.report_type = rep.report_type
              rsp_to_add.short_label = rep.report_type[0].toUpperCase() + rep.report_type[1..-1].toLowerCase()
              rsp_to_add.report = rep
            profiles_to_display.push rsp_to_add

          if rep.status == "pending" or rep.status == "new"
            $scope.rpt_icon[rep.source_identifier] = rpt_pending_svg
          else if rep.status == "ready"
            $scope.rpt_icon[rep.source_identifier] = rpt_ready_svg
          else
            $scope.rpt_icon[rep.source_identifier] = rpt_error_svg
          return
      landlordDefer.promise.then (landlord) ->
        $scope.landlord = landlord
        $scope.application = application
        profile.show_new_card_dialog = !Boolean(landlord && landlord.card_on_file) for profile in profiles_to_display

        profiles_to_display.forEach $scope.load_this_profiles_report
        $scope.profiles_to_display = profiles_to_display
        $scope.application_ready = $scope.application.status in ['A', 'R', 'S']
        $scope.appLandlord = appLandlord
        $scope.profiles = profiles_to_display

        $scope.$broadcast 'application_loaded'
        $scope.decision_date = new Date($scope.application.decision_date)
        $scope.modified_date = new Date($scope.application.modified)
        if $scope.mobile_view
          $scope.mobile_tab_nav_width = "#{160*($scope.profiles_to_display.length + 1)}px"
          $scope.tab_width = "160px"
          $scope.tab_font_size = "15px"
        else
          $scope.tab_width = "#{100.0/($scope.profiles_to_display.length + 1)}%"
          if $scope.profiles_to_display.length + 1 > 4
            $scope.tab_font_size = "16px"
        $state.go("root.dashboard.view_application.application", {application: $scope.application})
        
        if $scope.bundle.first_share_view
          $scope.open_welcome_modal()

    $scope.load_bundle = (selected_appid) ->
      $scope.loading_application = true;
      ApplicationBundle.query
        applications__id: selected_appid
        with_stripe_data: true
        view: true
      .$promise.then (bundle_response) ->
        bundle = bundle_response.objects[0]
        $scope.bundle = bundle
        if !bundle
          $state.go("root.home.404")
          return
        $scope.load_application(selected_appid)

      .catch (err)->

        if RentappService.isLoggedIn()
          $state.go "root.home.403"
        else
          if $rootScope.WHITE_LABEL
            $state.go("root.home.landing", { view_app: selected_appid })
          else
            $state.go("root.home.login", { view_app: selected_appid })
      .finally () ->
        $scope.loading_application = false;
    
    $scope.load_bundle($stateParams.application_id)

    $scope.download_application = (application) ->
      $scope.downloading_application_pdf = true
      $scope.toggle_download_dropdown()
      $http
      .get "#{RENTAPPLICATION_API_URL}#{application.pdf_url}", {responseType: 'blob'}
      .then (res) ->
        saveAs(res.data,  "#{application.applicant_name}__application.pdf")
        $scope.downloading_application_pdf = false
      .finally ->
        $scope.downloading_application_pdf = false
        
    $scope.download_report = (report) ->
      $scope.downloading_report_pdf = true
      $scope.toggle_download_dropdown()
      $http.get "#{RENTAPPLICATION_API_URL}#{report.report_pdf_url}",
        {responseType: 'blob'}
      .then (res) ->
        saveAs(res.data, "#{$scope.application.applicant_name}__#{report.report_source_profile.short_label}.pdf")
      .finally ->
        $scope.downloading_report_pdf = false;

    $scope.load_report_html = (report) ->
      if report.html
        return
      report.loading_html = true
      $http.get "#{RENTAPPLICATION_API_URL}#{report.report_html_url}"
      .then (response) -> report.html = $sce.trustAsHtml(response.data)
      .finally -> report.loading_html = false


    $scope.load_this_profiles_report = (profile, application) ->
      profile.loading = true;

      # For Smartmove reports, reports should exist
      if profile.identifier.indexOf('smartmove') < 0
        report = _.find($scope.application.reports, {'source_identifier': profile.identifier})
      else
        report = profile.report

      # If no report is found for the profile,
      # skip trying to load report from backend
      if !report
        profile.loading = false;
        profile.report = null;
        missing_fields = _.difference(profile.report_source.required_fields, $scope.app_field_names)
        is_sharee = $scope.bundle.is_request_user_sharee

        profile.can_buy_report = missing_fields.length == 0 and !(profile.identifier.includes('credit') and is_sharee)
        if !profile.can_buy_report
          profile.missing_fields = []
          missing_fields.forEach (name) ->
            profile.missing_fields.push name

        profile.card = {};
        return

      # If report is found for the profile,
      # use report id (resource_uri) for direct access
      $http
        url: "#{RENTAPPLICATION_API_URL}#{report.resource_uri}"
        method: "GET"

      .then (resp) ->
        profile.loading = false;
        data = resp.data
        profile.report = data;

        if profile.report.status == "pending" or profile.report.status == "new"
          $scope.rpt_icon[profile.report.identifier] = rpt_pending_svg
          $timeout(
            () -> $scope.load_this_profiles_report(profile),
            30000
          )
          return;

        if profile.report.status == "ready"
          $scope.rpt_icon[profile.report.identifier] = rpt_ready_svg
          profile.loading = true;

          $http.get "#{RENTAPPLICATION_API_URL}#{profile.report.report_html_url}"
          .then (resp) ->
            profile.report.rendered_html = $sce.trustAsHtml(resp.data);
          .catch (err) ->
            if _.isObject(err)
              profile.error = {}
              profile.error.type = err.data.type
            else
              profile.error = true;
          .then () ->
            profile.loading = false;

        if profile.report.status == "not_found" || profile.report.status == "fatal"
          $scope.rpt_icon[profile.report.identifier] = rpt_error_svg

          if profile.report.error_code == 104 and profile.report.missing_fields
            profile.error = {
              "type": "missing_required_report_fields",
              "missing_fields": profile.report.missing_fields
            }
          else
            profile.error = true
        
        if ['error', 'error_user_action_required'].indexOf(profile.report.status) >= 0
          profile.error = {}
          if data.type
            profile.error.type = data.type
          else
            profile.error = true
          profile.error.error_code = data.error_code

      .catch (err) ->
        profile.error = true;

    $scope.download_bundle = () ->
      $scope.bundle.applications.forEach (application) ->
        $scope.download_package application

    $scope.download_package = (application) ->
      $scope.downloading_package = true
      $scope.toggle_download_dropdown()
      zip_filename = [
        application.unit_address
        application.applicant_name
        moment(application.created).format('YYYY-MM-DD')
        application.id
      ].join('__').replace(RegExp(' ', 'g'), '_')
      attachment_requests = [ $http.get("#{RENTAPPLICATION_API_URL}#{application.pdf_url}",
        responseType: 'arraybuffer'
        contentType: 'application/pdf'
        filename: 'application.pdf').then((r) ->
        {
          'filename': "#{application.applicant_name}__application.pdf"
          'data': r.data
        }
      ).catch((e) ->
        return
      ) ]
      ready_report_promises = application.reports.filter((report) ->
        report.status == 'ready'
      ).map((report) ->
        $http.get(
          "#{RENTAPPLICATION_API_URL}#{report.report_pdf_url}",
          responseType: 'arraybuffer'
          contentType: 'application/pdf'
          filename: report.pdf_filename).then((r) ->
          {
            'filename': "#{application.applicant_name}__#{report.report_source_profile.short_label}.pdf"
            'data': r.data
          }
        ).catch (e) ->
          return
      )
      attachment_requests = attachment_requests.concat(ready_report_promises)
      attachment_promises = application.attachment_urls.map((url) ->
        $http.get("#{RENTAPPLICATION_API_URL}#{url}", responseType: 'arraybuffer').then((r) ->
          file_name_match = r.headers('Content-Disposition').match(/filename="([^"\\]*(?:\\.[^"\\]*)*)"/i)
          if file_name_match and file_name_match.length 
            return {
              'filename': "#{application.applicant_name}__#{file_name_match[1]}"
              'data': r.data
            }
          else 
            return {
              'filename': "#{application.applicant_name}__attachment__#{url.split("/").slice(-1)[0]}"
              'data': r.data
            }
        ).catch (e) ->
          return
      )
      attachment_requests = attachment_requests.concat(attachment_promises)
      $q.all(attachment_requests).then((attachments) ->
        require.ensure [], () ->
          JSZip = require "jszip"
          zip = new JSZip
          attachments.forEach (attachment) ->
            if !attachment
              return
            zip.file attachment.filename, attachment.data, binary: true
          zip.generateAsync(type: 'blob').then (content) ->
            saveAs content, zip_filename + '.zip'
      ).finally ->
        delete $scope.downloading_package

    $scope.buy_report = (profile, application, use_new_card) ->
      _buy_report = (stripeToken) ->
        profile.card.processing = true
        $http.post "#{RENTAPPLICATION_API_URL}#{application.resource_uri}buy_report/",
          'profile_source_identifier': profile.source_identifier
          'save_as_default': profile.card.save_as_default
          'use_default_card': profile.card.use_default_card
          'stripeToken': stripeToken
          'payment_receipt': profile.card.payment_receipt
        .then ->
          # Reload the page for newly updated profile
          $window.location.reload()
        .catch (result) ->
          profile.card.error =
            'type': ''
            'message': result
        .finally ->
          profile.card.processing = false

      _create_token = (callback) ->
        profile.card.processing = true
        RentappService.getStripe()
          .then((stripe) ->
            stripe.createToken(profile.card)
              .then((result) ->
                if result.error
                  $rootScope.$broadcast("card-error", result.error)
                  profile.card.processing = false
                else
                  callback result.token.id
              )
          )

      profile.card.error = null
      if profile.price == 0
        _buy_report null
      else if !use_new_card
        _buy_report null
      else
        _create_token _buy_report

    $scope.forgetCardConfirm = () ->
       $uibModal.open
          scope: $scope
          template: require("./ForgetCardPopup.jade")
          controller: require("./ForgetCardPopup.coffee")
       .result.then (removed) ->
          if removed
            profile.show_new_card_dialog = true for profile in $scope.application.landlord.report_source_profiles
       return



// WEBPACK FOOTER //
// ./components/dashboard/view/view.coffee